// extracted by mini-css-extract-plugin
export default {"painel":"styles_painel__Lcc5p","card":"styles_card__8AMfQ"};